import React from 'react';
import AsyncSection from '../../../../../../../../../../Components/AsyncSection';
import './index.scss';
import { formatDelta } from '../../constants';
import {
    GROUP_TEXT,
    HEADER_TEXT,
    deltaFor,
    scalePct,
    toneFor,
} from './constants';
import SVGIcons from '../../../../../../../../../../Components/SVGIcons';
import { getScaleConfig } from '../../../../../../utils/scaleConfig';

// One category: where its All But Self mean sat at the earlier 360 and where it
// sits now, as a dumbbell along the org's scale (1..6 or 1..4). The grey marker is the
// earlier round and the coloured one the latest, so the segment between them
// reads as the distance travelled and its direction.
const MovementRow = (props) => {
    const { row, scale } = props;
    const tone = toneFor(row.delta);
    const earlierPct = scalePct(row.earlier, scale);
    const latestPct = scalePct(row.latest, scale);
    const bandLeft = scalePct(scale.favorableThreshold, scale);
    const bandWidth = scalePct(scale.max, scale) - bandLeft;

    return (
        <div className='moved__row'>
            <span className='moved__category'>{row.category}</span>

            <div className='moved__plot'>
                <span className='moved__baseline' />
                <span className='moved__band' style={{ left: `${bandLeft}%`, width: `${bandWidth}%` }} />
                <span
                    className={`moved__connector moved__connector--${tone}`}
                    style={{
                        left: `${Math.min(earlierPct, latestPct)}%`,
                        width: `${Math.abs(latestPct - earlierPct)}%`,
                    }}
                />
                <span
                    className={`moved__marker moved__marker--earlier moved__marker--earlier-${tone}`}
                    style={{ left: `${earlierPct}%` }}
                    title={`Earlier ${row.earlier.toFixed(2)}`}
                />
                <span
                    className={`moved__marker moved__marker--latest moved__marker--${tone}`}
                    style={{ left: `${latestPct}%` }}
                    title={`Latest ${row.latest.toFixed(2)}`}
                />
            </div>

            <span className='moved__values'>
                {row.earlier.toFixed(2)} <span className='moved__values-arrow'>{`->`}</span> {row.latest.toFixed(2)}
            </span>

            <span className={`moved__delta moved__delta--${tone}`}>
                <SVGIcons type={"SVG-trendArrow"} />
                {/* <TrendArrow down={row.delta < 0} /> */}
                {formatDelta(row.delta)}
            </span>
        </div>
    );
};

const WhatMovedMost = (props) => {
    const api = props.fetchTrendSelfVsOthersApi;
    const scale = getScaleConfig(props.scaleType);
    const headerText = HEADER_TEXT(scale);
    // The API sends the two groups already split and ordered; rows carry no
    // delta, so it's derived here for the tone and the delta column.
    const withDelta = (rows) => (rows || []).map((row) => ({ ...row, delta: deltaFor(row) }));
    const improved = withDelta(api.data && api.data.categoryMovementData);
    const declined = withDelta(api.data && api.data.categoryDeclinedData);

    return (
        <AsyncSection api={api} isEmpty={() => !improved.length && !declined.length} loaderHeight={300} loaderWidth={600}>
        <div className='cardwrapper'>
            <h3>{headerText.title}</h3>
            <p className='description-container'>{headerText.description}</p>

            <div className='moved'>
                {/* Both groups share one grid so their columns line up across the
                    group headings that sit between them. */}
                <div className='moved__scroll'>
                    <div className='moved__groups'>
                        {improved.length > 0 && (
                            <>
                                <div className='moved__group-label'>{GROUP_TEXT.improved}</div>
                                {improved.map((row) => <MovementRow row={row} scale={scale} key={row.category} />)}
                            </>
                        )}

                        {declined.length > 0 && (
                            <>
                                <div className='moved__group-label'>{GROUP_TEXT.declined}</div>
                                {declined.map((row) => <MovementRow row={row} scale={scale} key={row.category} />)}
                            </>
                        )}
                    </div>
                </div>

                <p className='moved__note'>{headerText.note}</p>
            </div>
        </div>
        </AsyncSection>
    );
};

export default WhatMovedMost;
